import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import {getProductById, createProduct} from "../../utils/requestUtils";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Config from "../../core/config";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import ConfirmButton from "../common/ConfirmButton";
import DecimalInput from "../common/DecimalInput";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import DatePicker from "react-datepicker";
import Loading from "../../core/Loading";
import {UserPermission} from "../../utils/utils";
import {usePermission} from "../../core/PermissionContext";
import ProductSelectAsync from "../product/ProductSelectAsync";
import PaymentMethodValueSelect from "../paymentMehod/PaymentMethodValueSelect";
import ModalDiv from "../../ModalDiv";

const apiUrl = Config.apiUrl;

const AutomotiveServiceManager = () => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    const [loading, setLoading] = useRecoilState(loadingAtom);
    const [originalFormData, setOriginalFormData] = useState(null);

    const newEntity = {
        id: undefined,
        customerName: '',
        customerPhone: '',
        customerEmail: '',
        car: '',
        carBrand: '',
        licensePlate: '',
        mileage: 0,
        modelYear: new Date().getFullYear(),
        saleDate: new Date(),
        deliveryDate: undefined,
        totalValue: 0.0,
        value: 0.0,
        shippingCost: 0.0,
        discount: 0.0,
        paidValue: 0.0,
        status: 'OPENING',
        productionArea: 'LOCAL',
        deliveryType: 'LOCAL',
        details: '',
        address: '',
        addressNumber: '',
        addressComplement: '',
        neighborhood: '',
        cep: '',
        city: '',
        state: '',
        cpfCnpjDelivery: '',
        issueNfSeries1: false,
        items: [],
        paymentMethods: [],
        receivables: [],
        files: [],
        code: '',
        user: undefined,
        sector: undefined,
        paymentTerm: undefined
    };

    const newItem = {
        id: undefined,
        product: {id: undefined, name: ''},
        quantity: 1,
        value: 0.0,
        type: '',
        user: undefined
    };

    const [formData, setFormData] = useState(newEntity);
    const [items, setItems] = useState([newItem]);

    useEffect(() => {
        makeQuery();
    }, [id]);

    async function makeQuery() {
        if (id) {
            try {
                const url = apiUrl + '/api/automotiveservices/id=' + id;
                setLoading(true);
                const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
                if (response.saleDate) {
                    response.saleDate = new Date(response.saleDate);
                }
                if (response.deliveryDate) {
                    response.deliveryDate = new Date(response.deliveryDate);
                }
                setFormData(response);
                setItems(response.items && response.items.length > 0 ? [...response.items, newItem] : [newItem]);
                setOriginalFormData(response); // Set original data for comparison
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        } else {
            setFormData(newEntity);
            setItems([newItem]);
            setOriginalFormData(null); // No original data for new entity
        }
    }

    function clearEntity() {
        setFormData(newEntity);
        setItems([newItem]);
    }

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleDateChange = (name, date) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: date
        }));
    };

    const handleItemChange = (index, field, value) => {
        const updatedItems = [...items];
        updatedItems[index] = {
            ...updatedItems[index],
            [field]: value
        };
        setItems(updatedItems);
    };

    const removeItem = (index) => {
        if (!window.confirm('Deseja realmente excluir este item?')) {
            return;
        }
        const updatedItems = items.filter((_, i) => i !== index);
        setItems(updatedItems);
    };

    async function selectProduct(productId, indexItem) {
        const product = await getProductById(productId);
        
        const updatedItems = [...items];
        updatedItems[indexItem].product.code = product.code;
        updatedItems[indexItem].product.name = product.name;
        updatedItems[indexItem].product.id = product.id;
        
        // Definir automaticamente o tipo se o produto já tiver um tipo
        if (product.type) {
            updatedItems[indexItem].type = product.type;
        }
        
        // Aplicar automaticamente o valor do produto se for maior que zero
        if (product.value && product.value > 0) {
            updatedItems[indexItem].value = product.value;
        }
        
        setItems(updatedItems);
        
        // Add a new empty item if this is the last item
        if (indexItem === items.length - 1) {
            setItems(prevItems => [...prevItems, {...newItem}]);
        }
    }

    const handleProductItemClick = async (id, index) => {
        setLoading(true);
        if (index === items.length - 1) {
            // Clear the ProductSelectAsync value for the last item
            // The selectProduct function will add a new empty item, which will clear the current selection
        }
        await selectProduct(id, index);
        setLoading(false);
    };

    const handleProductInputChange = (inputValue, index) => {
        // Update the item with the input value when no product is selected
        const updatedItems = [...items];
        if (!updatedItems[index].product.id || updatedItems[index].product.id === 0 || updatedItems[index].product.id === undefined) {
            updatedItems[index].product.name = inputValue;
            
            // Add a new empty item if this is the last item and user is typing
            if (index === items.length - 1 && inputValue && inputValue.trim() !== '') {
                updatedItems.push({...newItem});
            }
        }
        setItems(updatedItems);
    };

    function validateInputs() {
        if (!formData.customerName || formData.customerName === '') {
            alert('Preencha o campo Cliente.');
            return false;
        }

        if (!formData.customerPhone || formData.customerPhone === '') {
            alert('Preencha o campo Telefone.');
            return false;
        }

        if (!formData.car || formData.car === '') {
            alert('Preencha o campo Carro.');
            return false;
        }

        if (!formData.carBrand || formData.carBrand === '') {
            alert('Preencha o campo Marca.');
            return false;
        }

        if (!formData.licensePlate || formData.licensePlate === '') {
            alert('Preencha o campo Placa.');
            return false;
        }

        if (!formData.saleDate) {
            alert('Preencha o campo Data do Serviço.');
            return false;
        }

        if (!formData.deliveryDate) {
            alert('Preencha o campo Data de Entrega.');
            return false;
        }

        if (items.length === 0) {
            alert('Adicione pelo menos um item ao serviço.');
            return false;
        }

        for (let i = 0; i < items.length-1; i++) {
            const item = items[i];
            if (!item.product.name || item.product.name === '') {
                alert(`Preencha o produto do item ${i + 1}.`);
                return false;
            }
            if (!item.type || item.type === '') {
                alert(`Selecione um tipo (Produto ou Serviço) para o item ${i + 1}.`);
                return false;
            }
            if (item.value === undefined || item.value === null || item.value < 0) {
                alert(`Preencha um valor válido (>= 0) para o item ${i + 1}.`);
                return false;
            }
        }

        return true;
    }

    const onConfirm = async () => {
        try {
            if (validateInputs()) {
                // Verificar se há pagamentos existentes e se o serviço foi modificado
                await saveEntity();
                navigate('/app/automotiveservicelist');
            }
        } catch (error) {
            console.error('Error saving:', error);
            alert('Erro ao salvar: ' + (error.message || error));
        } finally {
            setLoading(false);
        }
    };

    async function processItemsForSave() {
        const processedItems = [];
        
        for (const item of items) {
            // Skip empty items (last item in the list)
            if (!item.product || !item.product.name) {
                continue;
            }
            
            let processedItem = { ...item };
            
            // Check if product has zero or undefined ID
            if (!item.product.id || item.product.id === 0 || item.product.id === undefined) {
                try {
                    // Create new product with the name from ProductSelectAsync
                    const newProduct = await createProduct({
                        name: item.product.name,
                        stock: 0,
                        value: item.value || 0,
                        type: item.type || 'PRODUCT' // Incluir o tipo selecionado
                    });
                    
                    // Update the item with the new product
                    processedItem.product = {
                        id: newProduct.id,
                        name: newProduct.name,
                        code: newProduct.code
                    };
                } catch (error) {
                    console.error('Error creating product:', error);
                    throw new Error(`Erro ao criar produto: ${item.product.name}`);
                }
            }
            
            processedItems.push(processedItem);
        }
        
        return processedItems;
    }

    async function saveEntity(paymentMethodValues) {
        const userUUID = Cookies.get('userUUID');
        const url = apiUrl + '/api/automotiveservices';
        
        try {
            // Process items and create products if needed
            const processedItems = await processItemsForSave();
            
            // Ensure all required fields are set
            const dataToSave = {
                ...formData,
                items: processedItems,
                // Ensure required fields have default values
                value: Number(formData.value) || items.reduce((sum, item) => sum + (Number(item.value) * Number(item.quantity)), 0),
                shippingCost: formData.shippingCost || 0.0,
                discount: Number(formData.discount) || 0.0,
                totalValue: Number(formData.totalValue) || 0.0,
                paidValue: formData.paidValue || 0.0,
                status: formData.status || 'OPENING',
                productionArea: formData.productionArea || 'LOCAL',
                deliveryType: formData.deliveryType || 'LOCAL',
                // Ensure collections are initialized
                paymentMethods: paymentMethodValues || [],
                receivables: formData.receivables || [],
                files: formData.files || [],
                // Ensure automotive service specific fields
                mileage: formData.mileage || 0,
                modelYear: formData.modelYear || new Date().getFullYear()
            };

            setLoading(true);
            const response = await makeRequest(url, id ? 'PUT' : 'POST', {
                'Content-Type': 'application/json',
                'Useruuid': userUUID,
            }, JSON.stringify(dataToSave));
            setLoading(false);
            return response;
        } catch (error) {
            setLoading(false);
            throw error;
        }
    }

    // Calcular subtotal e total (subtotal + frete - desconto, não negativo)
    useEffect(() => {
        const sub = items.reduce((sum, item) => sum + (Number(item.value) * Number(item.quantity)), 0);
        const shipping = Number(formData.shippingCost) || 0;
        const discount = Number(formData.discount) || 0;
        const total = Math.max(0, sub + shipping - discount);
        setFormData(prev => ({...prev, value: sub, totalValue: total}));
    }, [items, formData.shippingCost, formData.discount]);

    // Função para verificar se houve modificações no serviço
    const hasServiceBeenModified = () => {
        if (!originalFormData) return false;
        
        // Comparar campos principais
        const fieldsToCompare = [
            'customerName', 'customerPhone', 'customerEmail', 'car', 'carBrand', 
            'licensePlate', 'mileage', 'modelYear', 'deliveryDate', 'status',
            'value', 'shippingCost', 'discount', 'totalValue', 'details', 'address', 
            'addressNumber', 'addressComplement', 'neighborhood', 'cep', 'city', 'state'
        ];
        
        for (const field of fieldsToCompare) {
            if (formData[field] !== originalFormData[field]) {
                return true;
            }
        }
        
        // Comparar itens
        if (items.length !== (originalFormData.items?.length || 0)) {
            return true;
        }
        
        for (let i = 0; i < items.length; i++) {
            const currentItem = items[i];
            const originalItem = originalFormData.items?.[i];
            
            if (!originalItem) return true;
            
            if (currentItem.product?.name !== originalItem.product?.name ||
                currentItem.quantity !== originalItem.quantity ||
                currentItem.value !== originalItem.value ||
                currentItem.type !== originalItem.type) {
                return true;
            }
        }
        
        return false;
    };

    // Função para lidar com a confirmação do pagamento
    const handlePaymentConfirm = async (paymentMethodValues) => {
        try {
            setLoading(true);


                await saveEntity(paymentMethodValues);
                navigate('/app/automotiveservicelist');

        } catch (error) {
            console.error('Error updating payments:', error);
            alert('Erro ao atualizar pagamentos. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };

    if (loadingPermissions) {
        return <Loading/>
    }

    if(hasUserPermission(UserPermission.CREATE_AUTOMOTIVE_SERVICE) === false || (hasUserPermission(UserPermission.EDIT_AUTOMOTIVE_SERVICE) === false && id)) {
        navigate('/unauthorizedaccess');
    }

    return (
        <div style={{width: '1000px'}}>
            <div className="header-label">{formData.id > 0 ? 'Editar' : 'Cadastrar'} Serviço Automotivo {formData.id > 0 ? '-' : ''} {formData.code}</div>

            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Cliente:</div>
                    <input type="text" style={{width: '300px'}} value={formData.customerName} name="customerName"
                           onChange={handleChange} data-test="customer-name-input"/>
                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Telefone:</div>
                    <input type="text" style={{width: '300px'}} value={formData.customerPhone} name="customerPhone"
                           onChange={handleChange} data-test="customer-phone-input"/>
                </div>
            </div>

            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Carro:</div>
                    <input type="text" style={{width: '200px'}} value={formData.car} name="car"
                           onChange={handleChange} data-test="car-input"/>
                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Marca:</div>
                    <input type="text" style={{width: '200px'}} value={formData.carBrand} name="carBrand"
                           onChange={handleChange} data-test="car-brand-input"/>
                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Placa:</div>
                    <input type="text" style={{width: '150px'}} value={formData.licensePlate} name="licensePlate"
                           onChange={handleChange} data-test="license-plate-input"/>
                </div>
            </div>

            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Quilometragem:</div>
                    <input type="number" style={{width: '150px'}} value={formData.mileage} name="mileage"
                           onChange={handleChange} data-test="mileage-input"/>
                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Ano do Modelo:</div>
                    <input type="number" style={{width: '150px'}} value={formData.modelYear} name="modelYear"
                           onChange={handleChange} data-test="manufacturing-year-input" min="1900" max="2030"/>
                </div>
            </div>

            <div style={{display: 'flex'}}>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Data do Serviço:</div>
                    <DatePicker
                        className="datepicker"
                        selected={formData.saleDate}
                        onChange={(date) => handleDateChange('saleDate', date)}
                        dateFormat="dd/MM/yyyy"
                        autoComplete="off"
                        data-test="service-date-picker"
                    />
                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Data de Entrega:</div>
                    <DatePicker
                        className="datepicker"
                        selected={formData.deliveryDate}
                        onChange={(date) => handleDateChange('deliveryDate', date)}
                        dateFormat="dd/MM/yyyy"
                        autoComplete="off"
                        data-test="delivery-date-picker"
                    />
                </div>
                <div style={{marginTop: '5px', alignItems: 'center'}}>
                    <div>Status:</div>
                    <select
                        value={formData.status}
                        onChange={(e) => handleChange(e)}
                        name="status"
                        data-test="status-select"
                    >
                        <option value="OPENING">Abertura</option>
                        <option value="PRODUCTION">Produção</option>
                        <option value="CONCLUDED">Concluído</option>
                        <option value="CANCELED">Cancelado</option>
                    </select>
                </div>
            </div>

            <div>
                <table style={{width: '100%', marginTop: '10px',minHeight: '200px' }}>
                    <thead>
                        <tr>
                            <th style={{width: '200px'}}>Produto/Serviço</th>
                            <th style={{width: '100px'}}>Tipo</th>
                            <th style={{width: '80px'}}>Quantidade</th>
                            <th style={{width: '120px'}}>Valor (R$)</th>
                            <th style={{width: '120px'}}>Total (R$)</th>
                            <th style={{width: '80px'}}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <div style={{display: 'flex', alignItems: 'center', width: '300px'}}>
                                        <ProductSelectAsync
                                            style={{width: '300px', menuWidth: '350px'}}
                                            value={item.product && item.product.id ? item.product.id : null}
                                            onItemClick={(id) => handleProductItemClick(id, index)}
                                            prefilledProduct={item.product && item.product.id ? item.product : null}
                                            index={index}
                                            dataTest={`product-async-select-${index}`}
                                            onInputValueChange={(inputValue) => handleProductInputChange(inputValue, index)}
                                        />
                                    </div>
                                </td>
                                {item.product.name && (

                                    <>
                                        <td>
                                            <div>
                                                <select
                                                    style={{
                                                        width: '90px',
                                                        backgroundColor: item.type === '' ? '#ffebee' : 'white',
                                                        border: item.type === '' ? '1px solid #f44336' : '1px solid #ccc'
                                                    }}
                                                    value={item.type}
                                                    onChange={(e) => handleItemChange(index, 'type', e.target.value)}
                                                    data-test={`item-type-${index}`}
                                                >
                                                    <option value="">Selecionar Tipo</option>
                                                    <option value="PRODUCT">Produto</option>
                                                    <option value="SERVICE">Serviço</option>
                                                </select>
                                                {item.type === '' && (
                                                    <div style={{
                                                        fontSize: '10px',
                                                        color: '#f44336',
                                                        marginTop: '2px'
                                                    }}>
                                                        Selecione um tipo
                                                    </div>
                                                )}
                                            </div>
                                        </td>

                                        <td>
                                            <input
                                                type="number"
                                                style={{width: '70px'}}
                                                value={item.quantity}
                                                onChange={(e) => handleItemChange(index, 'quantity', parseInt(e.target.value) || 1)}
                                                min="1"
                                                data-test={`item-quantity-${index}`}
                                            />
                                        </td>
                                        <td>
                                            <DecimalInput
                                                style={{width: '100px', textAlign: 'right'}}
                                                value={item.value}
                                                onChange={(e) => {
                                                    handleItemChange(index, 'value', e.target.value);
                                                }}
                                                data-test={`item-value-${index}`}
                                            />
                                        </td>
                                        <td>
                                            <div style={{textAlign: 'right'}}>
                                                {(Number(item.quantity) * Number(item.value)).toLocaleString('pt-BR', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </div>
                                        </td>
                                        <td>
                                            <button
                                                className="remove-button"
                                                onClick={() => removeItem(index)}
                                                data-test={`remove-item-${index}`}
                                            >
                                                Excluir
                                            </button>
                                        </td>
                                    </>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="total-label" style={{height: '37.6px', display: 'flex', alignItems: "center"}}>
                <div style={{display: 'flex', gap: '16px', alignItems: 'center'}}>
                    <div>
                        Desconto (R$):&nbsp;
                        <DecimalInput
                            style={{width: '100px', textAlign: 'right'}}
                            name="discount"
                            value={formData.discount}
                            onChange={handleChange}
                            data-test="discount-input"
                        />
                    </div>
                    <div>
                        Valor Total: R$ {Number(formData.totalValue || 0).toLocaleString('pt-BR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}
                    </div>
                </div>
            </div>

            <ActionButtonsManagerView>
                <ConfirmButton onClick={onConfirm}/>
            </ActionButtonsManagerView>
        </div>
    );
};

export default AutomotiveServiceManager;
